<template>
    <section class="text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'home' }" />
        <Title>Love Letter</Title>
        <div class="space-y-6 pt-8">
            <input class="shadow appearance-none border rounded w-full py-2 px-3 mr-4 bg-gray-800 border-gray-600 text-gray-200" placeholder="Nom d'utilisateur" v-model="username">
            <button class="w-full bg-gradient-to-r from-blue-400 to-blue-500 text-white font-bold py-4 px-4 rounded"
                :class="{ 'opacity-50': username == null }"
                @click="HandleStart">
                Démarrer une nouvelle partie
            </button>
            <div class="flex mt-4">
                <input class="shadow appearance-none border rounded w-full py-2 px-3 mr-4 bg-gray-800 border-gray-600 text-gray-200" placeholder="Code" v-model="code">
                <button class="flex-no-shrink p-2 border-2 rounded border-gray-200 text-gray-200"
                    :class="{ 'opacity-50': username == null || code == null }"
                    @click="HandleJoin">Rejoindre</button>
            </div>
        </div>
    </section>
</template>
<script>
import { mapFields } from '@/models'
import { mapActions, mapState } from 'vuex'
export default {
    computed: {
        ...mapFields('LoveLetter', ['username', 'code'])
    },
    methods: {
        ...mapActions('LoveLetter', ['StartNewGame', 'JoinGame']),
        async HandleStart() {
            if (this.username == null) return;
            await this.StartNewGame()
                .then(() => this.$router.push({ name: 'love-letter-play' }))
        },
        async HandleJoin() {
            if (this.username == null || this.code == null) return;
            await this.JoinGame()
                .then(() => this.$router.push({ name: 'love-letter-play' }))
                .catch((err) => {
                    console.log(err);
                    this.showError(err.message)
                })
        }
    }
}
</script>